import type { PickerTexts } from '@roommatik/directory-client';

/** English picker texts, for when the panel is shown in English (the element ships es-ES by default). */
export const englishPickerTexts: Partial<PickerTexts> = {
  searchPlaceholder: { property: 'Search for a property in the registry', organization: 'Search for an organization in the registry' },
  searching: 'Searching…',
  noResults: 'No results with that name.',
  loadMore: 'Show more results',
  change: 'Change',
  clear: 'Remove',
  unreachable: 'The registry could not be reached.',
  retry: 'Retry',
  required: 'This field is required.',
  kinds: {
    hotel: 'Hotel',
    hostel: 'Hostel',
    residence: 'Residence',
    apartments: 'Apartments',
    car_rental: 'Car rental',
    other: 'Other',
    customer: 'Customer',
    chain: 'Chain',
    brand: 'Brand',
    billing: 'Billing',
    integrator: 'Integrator',
    internal: 'Internal',
  },
};
